import React, { useState, useEffect, useContext } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import StatusCustomDropdown from "../common/StatusCustomDropdown";
import config from "../../envconfig";
import { UserContext } from "../common/UserContext";
import { IoCaretUpOutline, IoCaretDownOutline } from 'react-icons/io5';

function CitpmEdit() {
  const [message, setMessage] = useState("");
  const {
    UM_GroupId,
    UM_CompanyGrpID,
    selectedScpId,
    UM_CompanyID,
    UM_UserId,
    UM_UserCode,
    UM_DefaultSCPId,
    UM_UserType
  } = useContext(UserContext);
  const [pwdValidationReset, setPwdValidationReset] = useState(false);
  const { CITPM_PolicyID } = useParams();
  const [enumValues, setEnumValues] = useState([]);
  const [PolicyName, setPolicyname] = useState("");
  const [selectedSCP, setSelectedSCP] = useState("");
  const [initialStatus, setInitialStatus] = useState("");
  const [CITPMEditold, setCITPMEditold] = useState({
    CITPM_PolicyName: PolicyName,
    CITPM_SessionTimeOut: "",
    CITPM_FailAttempt: "",
    passwordNeverExpire: "",
    CITPM_PwdChangeDuration: "",
    CITPM_PwdNotificationDuration: "",
    CITPM_PwdNeverExpiry: 0,
    CITPM_Status: 1,
    CITPM_ModifiedBy: UM_UserId,
    SCPM_Name: selectedScpId,
  });

  const [CITPMEdit, setCITPMEdit] = useState({
    CITPM_PolicyName: PolicyName,
    CITPM_SessionTimeOut: "",
    CITPM_FailAttempt: "",
    passwordNeverExpire: false,
    CITPM_PwdChangeDuration: "",
    CITPM_PwdNotificationDuration: "",
    CITPM_PwdNeverExpiry: 0,
    CITPM_Status: 1,
    CITPM_ModifiedBy: UM_UserId,
    SCPM_Name: selectedScpId,
    PolicyType: "",

  });

  const [submittedWithoutValue, setSubmittedWithoutValue] = useState(false);
  const [errorMessages, setErrorMessages] = useState({});

  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    sessionStorage.setItem("UM_GroupId", UM_GroupId);
    sessionStorage.setItem("UM_CompanyGrpID", UM_CompanyGrpID);
    sessionStorage.setItem("UM_DefaultSCPId", UM_DefaultSCPId);
    sessionStorage.setItem("UM_CompanyID", UM_CompanyID);
    sessionStorage.setItem("UM_UserId", UM_UserId);
    sessionStorage.setItem("UM_UserCode", UM_UserCode);
    sessionStorage.setItem("selectedScpId", selectedScpId);
    sessionStorage.setItem("UM_UserType", UM_UserType);
  }, [
    UM_GroupId,
    UM_CompanyGrpID,
    UM_DefaultSCPId,
    UM_CompanyID,
    UM_UserId,
    UM_UserCode,
    selectedScpId,
    UM_UserType,
  ]);

  const logAudit = async (
    module,
    message,
    CompanyID,
    CompanyGrpID,
    oldValue = "",
    newValue = "",
    isError = false,
    transactionDetails = []
  ) => {
    const auditLogPayload = {
      AUTR_ScreenName: module,
      AUTR_OldValue: oldValue,
      AUTR_NewValue: newValue,
      AUTR_Message: message,
      AUTR_UserID: UM_UserId,
      AUTR_UserName: UM_UserCode,
      AUTR_AuditType: 3,
      AUTR_SCPID: selectedScpId || 0,
      AUTR_CompanyGrpId: CompanyGrpID,
      AUTR_CompanyID: CompanyID,
      AUTR_CreatedBy: UM_UserId,
      insertAuditTransaction: transactionDetails.length > 0, // Flag to determine if transaction details should be inserted
      transactionDetails, // Array of transaction details to be inserted into audittransaction
    };

    try {
      const response = await fetch(`${config.API_URL}/audit/log`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(auditLogPayload),
      });

      if (!response.ok) {
        throw new Error("Failed to log action");
      }
    } catch (error) {
      console.error("Error logging action:", error);
    }
  };

  const logAction = async (action, isError = false) => {
    try {
      const response = await fetch(`${config.API_URL}/api/log`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          module: "Company IT Policy Master",
          action,
          userCode: UM_UserCode,
          isError,
        }),
      });

      if (!response.ok) {
        logAction("Failed to log action");
        throw new Error("Failed to log action");
      }
    } catch (error) {
      logAction("Error logging action:", true);
      console.error("Error logging action:", error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${config.API_URL}/CITPM/EDIT/${CITPM_PolicyID}`
        );
        if (response.ok) {
          const data = await response.json();


          if (Object.keys(data).length !== 0) {
            const pwdNeverExpiryValue = data.CITPM_PwdNeverExpiry ?? 0;

            console.log("data", data, pwdNeverExpiryValue)


            const oldData = {
              CITPM_PolicyName: data.CITPM_PolicyName || "",
              CITPM_SessionTimeOut: data.CITPM_SessionTimeOut || "",
              CITPM_FailAttempt: data.CITPM_FailAttempt || "",
              CM_CompanyName: data.CM_CompanyName || "",
              passwordNeverExpire: pwdNeverExpiryValue === 1,
              CITPM_PwdChangeDuration: data.CITPM_PwdChangeDuration || "",
              CITPM_PwdNotificationDuration:
                data.CITPM_PwdNotificationDuration || "",
              CITPM_PwdNeverExpiry: pwdNeverExpiryValue,
              CITPM_Status: data.CITPM_Status || 1,
              CITPM_ModifiedBy: UM_UserId,
              SCPM_ID: data.SCPM_ID || null, // Add SCPM_ID
              SCPM_Name: data.SCPM_Name || "", // Add SCPM_Name,
              PolicyType: data.PolicyType,
              CompanyID: data.CITPM_CompanyID,
              CompanyGrpID: data.CITPM_CompanyGrpID,
              PwdExpiryValue: pwdNeverExpiryValue
            };

            console.log("oldData", oldData)
            setCITPMEdit(oldData);
            setCITPMEditold(oldData); // Store the old values
            setInitialStatus(data.CITPM_Status);
            // Set the SCP name and ID from API response
            setSelectedSCP({
              SCPM_ID: data.SCPM_ID,
              SCPM_Name: data.SCPM_Name,
            });
          } else {
            console.error(
              "No data found for the provided CITPM_PolicyID:",
              CITPM_PolicyID
            );
          }
        } else {
          logAction("fetchData() : Error fetching the company data", true);
          console.error("Error fetching the company data");
        }
      } catch (error) {
        logAction("Error fetching company data:", true);
        console.error("Error fetching company data:", error);
      }
    };
    fetchData();
  }, [CITPM_PolicyID]);


  const validateInput = (fieldName, value) => {
    if (value === "") {
      return true; // Allow empty values
    }
    switch (fieldName) {
      case "CITPM_SessionTimeOut":
      case "CITPM_FailAttempt":
        const numberRegex = /^[1-9][0-9]{0,2}$/; // Integer between 1 to 999
        return numberRegex.test(value);
      case "CITPM_PwdChangeDuration":
        return (
          Number.isInteger(Number(value)) &&
          Number(value) >= 1 &&
          Number(value) <= 999
        );
      case "CITPM_PwdNotificationDuration":
        return (
          Number.isInteger(Number(value)) &&
          Number(value) >= 0 &&
          Number(value) <= 999
        );
      default:
        return true;
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const inputValue = type === "checkbox" ? checked : value;

    // 🔹 Numeric fields allowed (no leading zero, max 3 digits)
    const numericFields = [
      "CITPM_SessionTimeOut",
      "CITPM_FailAttempt",
      "CITPM_PwdChangeDuration",
      "CITPM_PwdNotificationDuration",
    ];

    if (
      numericFields.includes(name) &&
      !/^(?!0)[0-9]{0,3}$/.test(value) &&
      value !== "" // allow clearing
    ) {
      return;
    }

    // 🔸 Update state
    setCITPMEdit((prevState) => ({
      ...prevState,
      [name]: inputValue,
    }));

    // 🧹 Clear error first when user types
    if (name === "CITPM_PwdChangeDuration" || name === "CITPM_PwdNotificationDuration") {
      setErrorMessages((prevErrors) => ({
        ...prevErrors,
        CITPM_PwdNotificationDuration: "",
      }));
    }

    // 🟥 LIVE VALIDATION: Notification < Change Duration
    if (
      name === "CITPM_PwdChangeDuration" ||
      name === "CITPM_PwdNotificationDuration"
    ) {
      const changeDuration = parseInt(
        name === "CITPM_PwdChangeDuration" ? value : e.target.form.CITPM_PwdChangeDuration.value
      );
      const notification = parseInt(
        name === "CITPM_PwdNotificationDuration" ? value : e.target.form.CITPM_PwdNotificationDuration.value
      );

      if (
        !CITPMEdit.CITPM_PwdNeverExpiry &&      // Ensure non-expiry option is off
        changeDuration &&
        notification &&
        notification >= changeDuration
      ) {
        setErrorMessages((prevErrors) => ({
          ...prevErrors,
          CITPM_PwdNotificationDuration:
            "Password Expire Notification must be less than Password Change Duration",
        }));
      } else {
        setErrorMessages((prevErrors) => ({
          ...prevErrors,
          CITPM_PwdNotificationDuration: "",
        }));
      }
    }

    // ✨ Clear other messages if needed
    setErrorMessages((prevErrors) => ({
      ...prevErrors,
      [name]: "",  // remove default error
    }));
  };



  const handleCancel = () => {
    setCITPMEdit((prevCITPMEdit) => ({
      CITPM_PolicyName: prevCITPMEdit.CITPM_PolicyName, // Retain the policy name
      CITPM_SessionTimeOut: "",
      CITPM_FailAttempt: "",
      CITPM_PwdChangeDuration: "",
      CITPM_PwdNotificationDuration: "",
      CITPM_Status: 1,
      passwordNeverExpire: false,
      // Ensure this is reset to 0
      CITPM_ModifiedBy: UM_UserId,
      CM_CompanyName: CITPMEdit.CM_CompanyName,
      SCPM_ID: CITPMEdit.SCPM_ID || null, // Add SCPM_ID
      SCPM_Name: CITPMEdit.SCPM_Name || "", // Add SCPM_Name,
      PolicyType: CITPMEdit.PolicyType,
      CompanyID: CITPMEdit.CompanyID,
      CompanyGrpID: CITPMEdit.CompanyGrpID,
    }));
    setMessage("");
    setSubmittedWithoutValue(false);
    setErrorMessages({});
  };



  useEffect(() => {
    const fetchEnumOptions = async () => {
      try {
        const response = await fetch(`${config.API_URL}/CITPM/enumtype`);
        if (!response.ok) throw new Error("Failed to fetch enum options");

        const data = await response.json();
        console.log("DATA", data);

        const values = data.map(item => item.EnumVal);
        setEnumValues(values);  // Store in state
        console.log("EnumVal State:", values);

      } catch (error) {
        console.error("Error fetching enum options:", error);
      }
    };

    fetchEnumOptions();
  }, []);



  const handleSubmit = async (e) => {
    e.preventDefault();

    setPwdValidationReset(false);
    setSubmittedWithoutValue(true);
    const requiredFields = [
      "CITPM_PolicyName",
      "CITPM_SessionTimeOut",
      "CITPM_FailAttempt",
    ];
    const blankFields = requiredFields.filter(
      (field) =>
        typeof CITPMEdit[field] === "string" && CITPMEdit[field].trim() === ""
    );

    if (blankFields.length > 0) {

      return;
    }

    console.log("Initial Status:", initialStatus);
    console.log("first check CITPMEdit.CITPM_Status:", CITPMEdit.CITPM_Status);

    if (initialStatus === 1 && CITPMEdit.CITPM_Status !== 1) {
      try {
        const response = await fetch(
          `${config.API_URL}/CITPM/citpmstatus/${CITPM_PolicyID}`
        );
        const result = await response.json();

        if (response.status === 200 && result.activeUserCount > 0) {
          toast.error(
            `You cannot inactivate the Policy : ${CITPMEdit.CITPM_PolicyName} because a reference exists in the Group Master.`
          );
          return { error: "Active users are present. Cannot change status." };
        } else if (response.status === 404) {

          return { error: "Group not found." };
        }
      } catch (error) {
        console.error("Error fetching group status:", error);
        return { error: "Error fetching group status." };
      }
    }

    if (initialStatus === 2 && CITPMEdit.CITPM_Status === 1) {
      try {

        const response = await fetch(
          `${config.API_URL}/CITPM/citpmcmstatus/${CITPM_PolicyID}`
        );
        const result = await response.json();
        console.log("Response for company status check:", result);
        if (response.status === 200 && result.SuspendCompamy > 0) {
          toast.error(
            `You cannot activate the Policy : ${CITPMEdit.CITPM_PolicyName} because the  Company : ${CITPMEdit.CM_CompanyName} is suspended.`
          );
          return { error: "Suspend company is present. Cannot change status." };
        }
      } catch (error) {
        console.error("Error fetching group status:", error);
        return { error: "Error fetching group status." };
      }
      finally {
        logAction(`handleSubmit() : User attempted to change status of Policy : ${CITPMEdit.CITPM_PolicyName}`);
      }
    }

    if (Object.values(errorMessages).every((error) => !error)) {
      if (!CITPMEdit.passwordNeverExpire) {
        if (CITPMEdit.CITPM_PwdChangeDuration.trim() === "") {

          return;
        }

        if (CITPMEdit.CITPM_PwdNotificationDuration.trim() === "") {

          return;
        }
      }

      if (parseInt(CITPMEdit.CITPM_PwdChangeDuration) <= parseInt(CITPMEdit.CITPM_PwdNotificationDuration)) {
        const message = "Password Expire Notification must be less than Password Change Duration";

        setErrorMessages((prevErrors) => ({
          ...prevErrors,
          CITPM_PwdNotificationDuration: message,
        }));

        return;
      }
      console.log("edit data", CITPMEdit);

      const editInputvalue = {
        CITPM_PolicyName: CITPMEdit.CITPM_PolicyName || PolicyName,
        CITPM_SessionTimeOut: CITPMEdit.CITPM_SessionTimeOut,
        CITPM_FailAttempt: CITPMEdit.CITPM_FailAttempt,
        CITPM_PwdChangeDuration: CITPMEdit.passwordNeverExpire
          ? null
          : CITPMEdit.CITPM_PwdChangeDuration,
        CITPM_PwdNotificationDuration: CITPMEdit.passwordNeverExpire
          ? null
          : CITPMEdit.CITPM_PwdNotificationDuration,
        CITPM_PwdNeverExpiry: CITPMEdit.passwordNeverExpire ? 1 : 0,

        CITPM_ModifiedBy: UM_UserId,
        OldStatus: parseInt(CITPMEditold.CITPM_Status),
        CITPM_Status: CITPMEdit.CITPM_Status,
        CompanyGrpID: CITPMEdit.CompanyGrpID,
        CompanyID: CITPMEdit.CompanyID
      };


      const companyID =
        parseInt(UM_UserType) === 0
          ? CITPMEditold.CompanyID
          : UM_CompanyID;

      const CompanyGroupID =
        parseInt(UM_UserType) === 0
          ? CITPMEditold.CompanyGrpID
          : UM_CompanyGrpID;

      const transactionDetails = [
        {
          AUTRN_OldValue: CITPMEditold.CITPM_PolicyName,
          AUTRN_NewValue: CITPMEdit.CITPM_PolicyName,
          AUTRN_ParamererName: "Policy Name",
        },
        ...(parseInt(UM_UserType) === 0 || parseInt(UM_UserType) === 1
          ? [
            {
              AUTRN_OldValue: CITPMEditold.PolicyType,
              AUTRN_NewValue: CITPMEditold.PolicyType,
              AUTRN_ParamererName: "Policy Type",
            },
          ]
          : []),
        {
          AUTRN_OldValue: CITPMEditold.CITPM_SessionTimeOut,
          AUTRN_NewValue: CITPMEdit.CITPM_SessionTimeOut,
          AUTRN_ParamererName: "Session Time Out (Minutes)",
        },
        {
          AUTRN_OldValue: CITPMEditold.CITPM_FailAttempt,
          AUTRN_NewValue: CITPMEdit.CITPM_FailAttempt,
          AUTRN_ParamererName: "Password Attempts",
        },










        {
          AUTRN_OldValue: CITPMEditold.CITPM_PwdChangeDuration || "-",
          AUTRN_NewValue: CITPMEdit.CITPM_PwdChangeDuration || "-",
          AUTRN_ParamererName: "Password Change Duration (Days)",
        },
        {
          AUTRN_OldValue: CITPMEditold.CITPM_PwdNotificationDuration || "-",
          AUTRN_NewValue: CITPMEdit.CITPM_PwdNotificationDuration || "-",
          AUTRN_ParamererName: "Password Expire Notification (Days)",
        },
        {

          AUTRN_OldValue: parseInt(CITPMEditold.CITPM_PwdNeverExpiry) === 1 ? "True" : "False",
          AUTRN_NewValue: parseInt(editInputvalue.CITPM_PwdNeverExpiry) === 1 ? "True" : "False",

          AUTRN_ParamererName: "Password Never Expire",
        },

        {

          AUTRN_OldValue: parseInt(CITPMEditold.CITPM_Status) === 1 ? "Active" : "Inactive",
          AUTRN_NewValue: parseInt(CITPMEdit.CITPM_Status) === 1 ? "Active" : "Inactive",
          AUTRN_ParamererName: "Status",
        },
      ];

      try {
        setLoading(true);
        logAction(`handleSubmit() : Executing API : ${config.API_URL}/CITPM/update/${CITPM_PolicyID} with DATA : ${editInputvalue}`);
        const res = await fetch(
          `${config.API_URL}/CITPM/update/${CITPM_PolicyID}`,
          {
            method: "PATCH",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(editInputvalue),
          }
        );

        if (res.ok) {
          const resjson = await res.json();
          logAction(`Policy : ${CITPMEdit.CITPM_PolicyName} updated successfully`);
          
          toast.success(
            `Policy : ${CITPMEdit.CITPM_PolicyName} updated successfully.`,
            {
              onClose: () => {
                handleCancel();
                setLoading(false);
                navigate(`/dashboard/citpm`);
              },
            }
          );
          logAudit(
            "Company IT Policy Master",
            `Policy : ${CITPMEdit.CITPM_PolicyName} updated successfully`, companyID, CompanyGroupID,
            "-",
            `${CITPMEdit.CITPM_PolicyName}`,
            false,
            transactionDetails
          );
        } else {
          // 🔥 Read backend returned message (even when status is not 200)
          const errJson = await res.json().catch(() => null);
          const errorMessage = errJson?.message || "Error updating policy";

          toast.error(errorMessage);   // 👉 Show toast with backend message
          logAction(`handleSubmit() : Error updating Policy data | Message : ${errorMessage}`, true);
          console.error("Update failed:", errorMessage);
        }
      } catch (error) {
        console.error("Error updating user data:", error);
        logAction(`handleSubmit() : Error updating Policy data | Error : ${error}`, true);
      }
      
    } else {
      if (
        !CITPMEdit.passwordNeverExpire &&
        CITPMEdit.CITPM_PwdNotificationDuration.trim() === ""
      ) {
        setMessage(
          'Please fill in "Password Expired Notification (Days)" field.'
        );

      }
    }
  };

  return (
    <React.Fragment>
      <form onSubmit={handleSubmit}>
        <div className="main_container">
          <ToastContainer
            style={{
              marginTop: "73px",
              fontSize: "14px",
              width: "40%",
            }}
          />
          {loading && (
            <div style={{
              position: 'fixed', // Sit on top of the page content
              left: 0,
              top: 0,
              width: '100%', // Full width
              height: '100%', // Full height
              zIndex: 1000 // Sit on top of the other elements
            }} />
          )}
          <div className="row">
            <div className="col-md-12">
              <h5 className="formHeading"> Company IT Policy Master</h5>
              <p className="text-success">{message}</p>
              <div className="row">

                {parseInt(UM_UserType) === 0 && (
                  <>
                    <div className="col-md-6">
                      <div className="mb-3">

                        <label className="form-label">
                          Company Name</label>
                        <div className='select-container'>
                          <input
                            type="text"
                            style={{ backgroundColor: '#f2f2f2', color: '#6c757d' }}
                            className="select-box"
                            id="UM_CompanyID"
                            name="UM_CompanyID"
                            value={CITPMEdit.CM_CompanyName}
                            disabled
                          />
                          <div className="icon-container">
                            <IoCaretDownOutline />
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}

                {(() => {
                  const userType = parseInt(UM_UserType);

                  return ((userType !== 2 && userType !== 3) ||
                    (userType === 1 && enumValues.length > 1) ||
                    userType === 0);
                })() && (

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">
                          Policy Type</label>
                        <div className='select-container'>
                          <input
                            type="text"
                            style={{ backgroundColor: '#f2f2f2', color: '#6c757d' }}
                            className="select-box"
                            value={CITPMEdit.PolicyType}
                            disabled
                          />
                          <div className="icon-container">
                            <IoCaretDownOutline />
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">
                      Policy Name
                    </label>
                    <input
                      type="text"
                      name="CITPM_PolicyName"
                      className="form-input"

                      value={CITPMEdit.CITPM_PolicyName}
                      disabled
                      style={{ backgroundColor: '#f2f2f2', color: '#6c757d' }}
                    />
                  </div>
                </div>

                {String(CITPMEdit.PolicyType) === "SCP" &&
                  parseInt(UM_UserType) !== 2 &&
                  parseInt(UM_UserType) !== 3 && (
                    <div className="col-md-6">
                      <label className="form-label">SCP Name</label>
                      <div className='select-container'>
                        <input
                          type="text"
                          name="SCPM_Name"
                          className="form-input"
                          value={CITPMEdit.SCPM_Name || "N/A"}
                          disabled={true}
                          style={{ backgroundColor: '#f2f2f2', color: '#6c757d' }}
                        />
                        <div className="icon-container">
                          <IoCaretDownOutline />
                        </div>
                      </div>
                    </div>
                  )}

                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">
                      Password Attempts
                      {submittedWithoutValue &&
                        !CITPMEdit.CITPM_FailAttempt && (
                          <span className="text-danger">*</span>
                        )}
                    </label>
                    <input
                      type="text"
                      name="CITPM_FailAttempt"
                      className={`form-input ${errorMessages.CITPM_FailAttempt ? "is-invalid" : ""
                        }`}
                      placeholder=""
                      value={CITPMEdit.CITPM_FailAttempt}
                      onChange={handleChange}
                    />
                    {errorMessages.CITPM_FailAttempt && (
                      <div className="invalid-feedback">
                        {errorMessages.CITPM_FailAttempt}
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">
                      Session Time Out (Minutes)
                      {submittedWithoutValue &&
                        !CITPMEdit.CITPM_SessionTimeOut && (
                          <span className="text-danger">*</span>
                        )}
                    </label>
                    <input
                      type="text"
                      name="CITPM_SessionTimeOut"
                      className={`form-input ${errorMessages.CITPM_SessionTimeOut ? "is-invalid" : ""
                        }`}
                      placeholder=""
                      value={CITPMEdit.CITPM_SessionTimeOut}
                      onChange={handleChange}
                    />
                    {errorMessages.CITPM_SessionTimeOut && (
                      <div className="invalid-feedback">
                        {errorMessages.CITPM_SessionTimeOut}
                      </div>
                    )}
                  </div>
                </div>



                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-lable">Status</label>
                    <div className="select-container">
                      <StatusCustomDropdown
                        name="CITPM_Status"
                        options={[
                          { value: 1, label: "Active" },
                          { value: 2, label: "Inactive" },
                        ]}
                        value={CITPMEdit.CITPM_Status || 1} // Assuming '1' is the value for Active
                        onChange={handleChange}
                        idKey="value"
                        displayKey="label"
                      />
                      {/* <div className="icon-container">
                        <i>
                          <ion-icon name="caret-down-outline"></ion-icon>
                        </i>
                      </div> */}
                    </div>
                  </div>
                </div>




                <div className="row">
                  <div className="col-md-6">
                    <label>Password Never Expire</label>

                    <input
                      type="checkbox"
                      name="passwordNeverExpire"
                      className="form-check-input"
                      checked={CITPMEdit.passwordNeverExpire}
                      onChange={(e) => {
                        const newValue = e.target.checked;
                        setPwdValidationReset(true);

                        // Update the main state
                        setCITPMEdit((prev) => ({
                          ...prev,
                          passwordNeverExpire: newValue,
                          CITPM_PwdChangeDuration: newValue
                            ? ""
                            : prev.CITPM_PwdChangeDuration,
                          CITPM_PwdNotificationDuration: newValue
                            ? ""
                            : prev.CITPM_PwdNotificationDuration,
                        }));

                        // Clear error messages if checkbox is checked
                        if (newValue) {
                          setErrorMessages((prev) => ({
                            ...prev,
                            CITPM_PwdChangeDuration: "",
                            CITPM_PwdNotificationDuration: "",
                          }));
                        }
                      }}
                      style={{ marginLeft: "2px", width: "20px", height: "20px" }}
                    />

                  </div>
                </div>




                {!CITPMEdit.passwordNeverExpire && (
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">
                        Password Change Duration (Days)
                        {submittedWithoutValue && !pwdValidationReset &&
                          !CITPMEdit.CITPM_PwdChangeDuration && (
                            <span className="text-danger">*</span>
                          )}
                      </label>
                      <input
                        type="text"
                        name="CITPM_PwdChangeDuration"
                        className={`form-input inputfields ${errorMessages.CITPM_PwdChangeDuration
                          ? "is-invalid"
                          : ""
                          }`}
                        placeholder=""
                        value={CITPMEdit.CITPM_PwdChangeDuration}
                        onChange={handleChange}
                      />
                      {/* {errorMessages.CITPM_PwdChangeDuration && <div className="invalid-feedback">{errorMessages.CITPM_PwdChangeDuration}</div>} */}
                    </div>
                  </div>
                )}

                {!CITPMEdit.passwordNeverExpire && (
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">
                        {" "}
                        Password Expire Notification (Days){" "}
                        {submittedWithoutValue && !pwdValidationReset &&
                          !CITPMEdit.CITPM_PwdNotificationDuration && (
                            <span className="text-danger">*</span>
                          )}
                      </label>
                      <input
                        type="text"
                        name="CITPM_PwdNotificationDuration"
                        className={`form-input inputfields ${errorMessages.CITPM_PwdNotificationDuration
                          ? "is-invalid"
                          : ""
                          }`}
                        placeholder=""
                        value={CITPMEdit.CITPM_PwdNotificationDuration}
                        onChange={handleChange}
                      />
                      {errorMessages.CITPM_PwdNotificationDuration && (
                        <div className="invalid-feedback">
                          {errorMessages.CITPM_PwdNotificationDuration}
                        </div>
                      )}
                    </div>
                  </div>
                )}

                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label"></label>
                    {Object.entries(errorMessages).map(
                      ([fieldName, errorMessage]) => (
                        <div key={fieldName} className="invalid-feedback">
                          {errorMessage}
                        </div>
                      )
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="button-container">
          <button type="submit" className="save_btn">
            SAVE
          </button>
          <button type="reset" className="reset_btn" onClick={handleCancel}>
            RESET
          </button>
          <Link to={`/citpm_list`} className="list_btn" type="button">
            LIST
          </Link>
        </div>
      </form>
    </React.Fragment>
  );
}

export default CitpmEdit;

